import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import {
  advisorSelector,
  committeeSelector,
  committeesSelector,
  setAdvisor,
  setCommittee,
  setCommittees,
  setIsCoordinator,
} from "../../store/advisorSlice";
import service from "./Helpers/gifservices";
import modules from "./modules/modules";

export default function Advisors() {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const advisor = useSelector(advisorSelector);
  const committees = useSelector(committeesSelector);
  const committee = useSelector(committeeSelector);

  useEffect(() => {
    service.GetAdvisorId().then((advisorId) => {
      dispatch(setAdvisor({id:advisorId}));
    });
  }, [dispatch])

  useEffect(() => {
    if (committees?.length > 0) return;
    service.GetAdvisorCommittees().then((committees) => {
      dispatch(setCommittees(committees));
      dispatch(setCommittee(committees[0]));
    });
  }, [dispatch, committees]);

  useEffect(() => {
    if (!advisor) return;
    if (!committee) return;
    if (
      advisor.id.toLowerCase() === committee.committeeCoordinator.toLowerCase()
    ) {
      dispatch(setIsCoordinator(true));
    } else dispatch(setIsCoordinator(false));
  }, [advisor, committee, dispatch]);

  return (
    <Switch>
      {modules.map(({ path, module: Module }) => (
        <Route
          key={path}
          path={`${match.url}${path}`}
          render={(props) => <Module {...props} baseUrl={match.url} />}
        />
      ))}
      <Redirect to={`${match.url}${modules[0].path}`} />
    </Switch>
  );
}
